export default __webpack_public_path__ + "static/winter42-6989c253b03547da58ae622ef479f518.webp";